export default "__VITE_ASSET__588acb48__"